import { FC } from "react";
import { Field, FormSpy } from "react-final-form";

/**
 * Keeps dirty fields mounted when components within the form are closed.
 * MUST be used within a react-final-form Form component and in conjunction with the keepDirtyOnReinitialize prop.
 *
 * @example
 * ```
 * <Form onSubmit={handleSubmit} keepDirtyOnReinitialize>
 *   <RememberUnmountedFields />
 *   {show && <Field name="name" />}
 * </Form>
 * ```
 * When the Field is unmounted, the `name` field in the `Form` will nonetheless remain dirty and keep its value.
 */

export const RememberUnmountedFields: FC = () => {
  return (
    <FormSpy subscription={{ dirtyFields: true }}>
      {({ dirtyFields }) =>
        Object.keys(dirtyFields).map(name => <Field key={name} name={name} subscription={{}} render={() => null} />)
      }
    </FormSpy>
  );
};
